import { useContext, useRef, useState } from "react";
import { AppContext } from "../contexts/AppContext";
import ImagePreview from "../components/ImagePreview";
import axios from "axios";
import axiosHttp from "../config/axios.interceptor";
import {
  base_url,
  dataURItoBlob,
  errorResponseMessage,
  httpHeaderConfig,
} from "./const.prop";
import { validateFile } from "../../utils/application-helper";
import Delete from "../shared/Delete";
import { AuthContext } from "../contexts/AuthContext";
import { useSelector } from "react-redux";

const PostPhoto = ({ data }) => {
  const appContext = useContext(AppContext);
  const authContext = useContext(AuthContext);
  const inputRef = useRef();
  const [loadedImage, setLoadedImage] = useState(data ? data?.url : "");
  const [croppedImage, setCroppedImage] = useState(null);
  const [postText, setPostText] = useState(data ? data?.description : "");
  const [showButton, setShowButton] = useState(false);
  const [cropEnabled, setCropEnabled] = useState(false);
  const [isNewImage, setNewImage] = useState(data?.url ? false : true);
  const [categoryId, setCategoryId] = useState(
    data?.skillCategoryId ? data?.skillCategoryId : ""
  );
  const [fileType, setFileType] = useState("");
  const { categoryList } = useSelector((state) => state.utilData);
  let dataURL = null;

  const triggerFileInputClick = () => inputRef.current.click();
  const imageChangeHandler = () => {
    const file = inputRef.current.files[0];
    const validationRes = validateFile(file, "image");
    if (validationRes.errors.length) {
      appContext.updateNotificationState({
        type: "error",
        message: validationRes.errors[0],
        show: true,
      });
      return;
    }
    setFileType(file.type.split("/")[1]);
    setLoadedImage(URL.createObjectURL(file));
  };
  const getCroppedImage = (croppedImage) => {
    setCroppedImage(croppedImage);
  };

  const postSubmit = (savedResponse) => {
    if (savedResponse && savedResponse.status !== 200) {
      appContext.updateNotificationState({
        type: "error",
        message: errorResponseMessage(error),
        show: true,
      });
      appContext.updateLoaderState(false);
    }
    const savedUrl = savedResponse ? savedResponse.data.tempPath : null;
    const savedThumbnail = savedResponse
      ? savedResponse.data.thumbnail_url
      : null;
    let formValues = {};
    if (data && data.id) {
      if (isNewImage) {
        formValues = {
          type: "image",
          text: postText,
          url: savedUrl,
          thumbnail_url: savedThumbnail,
          skillCategoryId: categoryId,
        };
      } else {
        formValues = {
          type: "image",
          text: postText,
          skillCategoryId: categoryId,
        };
      }

      axiosHttp
        .post(`post-data/${data?.id}`, formValues)
        .then((postResponse) => {
          if (postResponse.status === 201 || postResponse.status === 200) {
            appContext.updateLoaderState(false);
            appContext.updateModalState();
          }
        })
        .catch((error) => {
          if (error.response.status === 429) {
            appContext.updateNotificationState({
              show: true,
              message: errorResponseMessage(error),
              type: "error",
            });
            authContext.logout();
          }
          if (error.response?.status >= 500) {
            appContext.updateNotificationState({
              show: true,
              message: "Something went wrong, please try again later.",
              type: "error",
            });
            appContext.updateLoaderState(false);
            setShowButton(false);
            return;
          }
          appContext.updateNotificationState({
            type: "error",
            message: errorResponseMessage(error),
            show: true,
          });
          appContext.updateLoaderState(false);
          setShowButton(false);
        });
    } else {
      axiosHttp
        .post("post-data", {
          type: "image",
          text: postText,
          url: savedUrl,
          skillCategoryId: categoryId,
        })
        .then((postResponse) => {
          if (postResponse.status === 201 || postResponse.status === 200) {
            appContext.updateLoaderState(false);
            appContext.updateModalState();
          }
        })
        .catch((error) => {
          if (error.response.status === 429) {
            appContext.updateNotificationState({
              show: true,
              message: errorResponseMessage(error),
              type: "error",
            });
            authContext.logout();
          }
          if (error.response?.status >= 500) {
            appContext.updateNotificationState({
              show: true,
              message: "Something went wrong, please try again later.",
              type: "error",
            });
            appContext.updateLoaderState(false);
            setShowButton(false);
            return;
          }
          appContext.updateNotificationState({
            type: "error",
            message: errorResponseMessage(error),
            show: true,
          });
          appContext.updateLoaderState(false);
          setShowButton(false);
        });
    }
  };

  const postHandler = () => {
    if (cropEnabled === false) {
      if (loadedImage.startsWith("https")) {
        constructFormData();
      } else {
        fetch(loadedImage)
          .then((response) => response.blob())
          .then((blob) => {
            const reader = new FileReader();
            reader.onloadend = () => {
              dataURL = reader.result;
              constructFormData();
            };
            reader.readAsDataURL(blob);
          })
          .catch((error) => console.error("Error fetching blob:", error));
      }
    } else {
      constructFormData();
    }
  };

  const constructFormData = async () => {
    appContext.updateLoaderState(true);
    setShowButton(true);
    if (cropEnabled) {
      if (croppedImage === null) {
        postSubmit();
      }
    } else {
      if (dataURL === null) {
        postSubmit();
      }
    }
    const formData = new FormData();
    if (cropEnabled) {
      const blob = dataURItoBlob(croppedImage);
      const file = new File([blob], `image.${fileType}`, {
        type: `image/${fileType}`,
      });
      formData.append("image", file);
    } else {
      const blob = dataURItoBlob(dataURL);
      console.log("fileType", fileType);
      const file = new File([blob], `image.${fileType}`, {
        type: `image/${fileType}`,
      });
      formData.append("image", file);
    }
    if (isNewImage) {
      try {
        const result = await axios.post(base_url + "upload-image", formData, {
          headers: {
            ...httpHeaderConfig,
            "Content-Type": "multipart/form-data",
          },
        });
        if (result.status === 200) {
          postSubmit(result);
        }
      } catch (error) {
        if (error.response.data.status === 429) {
          appContext.updateNotificationState({
            show: true,
            message: errorResponseMessage(error),
            type: "error",
          });
          authContext.logout();
        } else if (error.response.data.status === 400) {
          appContext.updateNotificationState({
            show: true,
            message: errorResponseMessage(error),
            type: "error",
          });
          appContext.updateLoaderState(false);
          setShowButton(false);
        } else if (error.response?.status >= 500) {
          appContext.updateNotificationState({
            show: true,
            message: "Something went wrong, please try again later.",
            type: "error",
          });
          appContext.updateLoaderState(false);
          setShowButton(false);
          return;
        } else {
          appContext.updateNotificationState({
            type: "error",
            message: errorResponseMessage(error),
            show: true,
          });
          appContext.updateLoaderState(false);
          setShowButton(false);
        }
      }
    } else {
      postSubmit();
    }
    return;
  };

  const reUploadHandler = () => {
    setLoadedImage(null);
    setCropEnabled(false);
    setFileType("");
    inputRef.current.value = "";
    setNewImage(true);
  };

  const handleChange = (e) => {
    setPostText(e.target.value);
  };

  return (
    <>
      <div className="modal-body">
        <div className="form-group category-select">
          <select
            className="form-control custom-select"
            onChange={(e) => setCategoryId(e.target.value)}
            disabled={
              data?.skillCategoryId === "680c89f84f3447f6da04284f"
                ? true
                : false
            }
            value={categoryId}
          >
            <option value="">Select category</option>
            {categoryList.map((item) => {
              return <option value={item?._id}>{item?.name}</option>;
            })}
          </select>
        </div>
        <div className="card card-modal">
          <div className="d-flex align-items-center justify-content-center height-inherit">
            {!loadedImage && (
              <p
                className="file text-center img-txt cursor-pointer"
                onClick={triggerFileInputClick}
              >
                Click here to upload
              </p>
            )}
          </div>
          <div>
            {loadedImage && (
              <div className="image-wrapper">
                <Delete clickHandler={reUploadHandler} />
                <ImagePreview
                  imageSrc={loadedImage}
                  cropImageHandler={getCroppedImage}
                  cropEnabled={cropEnabled}
                />
              </div>
            )}
          </div>
          <input
            type="text"
            className="form-control mt-3"
            value={postText}
            onChange={handleChange}
            placeholder="description..."
          />
        </div>
        <input
          className="visible-hidden"
          onChange={imageChangeHandler}
          type="file"
          ref={inputRef}
        />
      </div>

      <div className="modal-footer">
        <div className="d-flex mt-3 justify-content-between w-100">
          <div>
            <span
              className="crop-btn cursor-pointer"
              onClick={() => {
                setCropEnabled(true);
                setNewImage(true);
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="26"
                viewBox="0 0 24 26"
                fill="none"
              >
                <path
                  d="M22 19.7666C22 19.9807 21.921 20.1862 21.7803 20.3376C21.6397 20.489 21.4489 20.5741 21.25 20.5741H18.25V23.8044C18.25 24.0186 18.171 24.224 18.0303 24.3755C17.8897 24.5269 17.6989 24.612 17.5 24.612C17.3011 24.612 17.1103 24.5269 16.9697 24.3755C16.829 24.224 16.75 24.0186 16.75 23.8044V20.5741H5.5C5.30109 20.5741 5.11032 20.489 4.96967 20.3376C4.82902 20.1862 4.75 19.9807 4.75 19.7666V7.653H1.75C1.55109 7.653 1.36032 7.56791 1.21967 7.41646C1.07902 7.26502 1 7.05961 1 6.84543C1 6.63124 1.07902 6.42584 1.21967 6.27439C1.36032 6.12294 1.55109 6.03786 1.75 6.03786H4.75V2.80757C4.75 2.59339 4.82902 2.38798 4.96967 2.23653C5.11032 2.08508 5.30109 2 5.5 2C5.69891 2 5.88968 2.08508 6.03033 2.23653C6.17098 2.38798 6.25 2.59339 6.25 2.80757V18.959H21.25C21.4489 18.959 21.6397 19.0441 21.7803 19.1955C21.921 19.347 22 19.5524 22 19.7666ZM8.5 7.653H16.75V16.5363C16.75 16.7505 16.829 16.9559 16.9697 17.1073C17.1103 17.2588 17.3011 17.3438 17.5 17.3438C17.6989 17.3438 17.8897 17.2588 18.0303 17.1073C18.171 16.9559 18.25 16.7505 18.25 16.5363V6.84543C18.25 6.63124 18.171 6.42584 18.0303 6.27439C17.8897 6.12294 17.6989 6.03786 17.5 6.03786H8.5C8.30109 6.03786 8.11032 6.12294 7.96967 6.27439C7.82902 6.42584 7.75 6.63124 7.75 6.84543C7.75 7.05961 7.82902 7.26502 7.96967 7.41646C8.11032 7.56791 8.30109 7.653 8.5 7.653Z"
                  fill="black"
                  fillOpacity="0.6"
                />
              </svg>
            </span>
          </div>
          <div>
            <button
              type="button"
              className="btn btn-outline-primary prime-btn mr-2"
              onClick={appContext.updateModalState}
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={postHandler}
              className="btn btn-outline-primary modal-btn"
              disabled={!loadedImage || showButton || categoryId === ""}
            >
              Done
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default PostPhoto;
